import { render, staticRenderFns } from "./Webshell.Edit.vue?vue&type=template&id=bd4856b4&"
import script from "./Webshell.Edit.vue?vue&type=script&lang=js&"
export * from "./Webshell.Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports